import axios from 'axios';
import {useInfiniteQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const provinces = async (data: LocationReqT) => {
  const {name, pageParam} = data;
  const qs = `?page=${pageParam ?? 1}&q=${name ?? ''}`;
  return axios.get(Routes.PROVINCES + qs);
};

export const useProvinces = (params: LocationReqT) => {
  const {name} = params;
  return useInfiniteQuery({
    queryKey: [Keys.PROVINCES_QRY, name],
    queryFn: ({pageParam = 1}) => provinces({pageParam, name}),
    getNextPageParam: lastPage => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    // cacheTime: 0,
    // staleTime: 0,
  });
};
